import React from 'react';

import { StyleSheet } from 'react-native';

import Picture from 'components/picture';
import { Box, BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';

//@TODO: GST-5568 - Modify StyledPicture and TextContentContainer to match with design
export const StyledPicture = Picture.withConfig({
  width: '100%',
  marginBottom: '$6',
});

export const TextContentContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.textContentContainer, style] });

export const ActionButtonsContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.actionButtonsContainer, style] });

const styles = StyleSheet.create({
  textContentContainer: {
    alignSelf: 'center',
    margin: spacing.$4,
  },
  actionButtonsContainer: {
    marginHorizontal: spacing.$12,
  },
});
